import { render, staticRenderFns } from "./PageFaq.vue?vue&type=template&id=80e6e1ec&scoped=true"
import script from "./PageFaq.vue?vue&type=script&lang=js"
export * from "./PageFaq.vue?vue&type=script&lang=js"
import style0 from "./PageFaq.vue?vue&type=style&index=0&id=80e6e1ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e6e1ec",
  null
  
)

export default component.exports